// Só a direção do movimento; o motivo (inventário, transferência, NF-e...) é a origem da movimentação.
export enum TipoOperacaoEstoqueEnum {
  Entrada = 1,
  Saida = 2,
}
